import React from 'react';

import { PatientRepository } from 'repositories/PatientRepository';
import { FormattedResponseJointType } from 'types/Patient';

const useJointData = (
  options: {
    patientId: string;
    side?: 'left' | 'right';
    isFromCronJob?:boolean
  }) => {
  const [isJointDataLoading, setIsJointDataLoading] = React.useState(options.isFromCronJob ?? false);
  const [jointData, setJointData] = React.useState<FormattedResponseJointType | null>();

  const getJointData = React.useCallback(async () => {
    try {
      setIsJointDataLoading(true);
      const patientRepository = PatientRepository.getInstance();

      const jointData = await patientRepository.getJointData(options.patientId);
      setJointData(jointData);
    } catch (error) {
      setJointData(null);
    } finally {
      setIsJointDataLoading(false);
    }
  }, [])

  React.useEffect(() => {
      getJointData();
  }, []);

  return {
    isJointDataLoading,
    jointData,
    setJointData,
  };
}

export default useJointData;
